import { render, staticRenderFns } from "./SellerComissionConfigsIndex.vue?vue&type=template&id=0b88fa0d&scoped=true"
import script from "./SellerComissionConfigsIndex.vue?vue&type=script&lang=js"
export * from "./SellerComissionConfigsIndex.vue?vue&type=script&lang=js"
import style0 from "./SellerComissionConfigsIndex.vue?vue&type=style&index=0&id=0b88fa0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88fa0d",
  null
  
)

export default component.exports